export default [{
    name: '全站',
    tid: 0,
    slug: 'all'
  },
  {
    // bangumi
    name: '番剧',
    type: 'bangumi',
    tid: 13,
    slug: 'bangumi',
    season_type: 1,
  },
  {
    // bangumi
    name: '国产动画',
    type: 'bangumi',
    tid: 168,
    slug: 'guochan',
    season_type: 4,
  },
  {
    name: '国创相关',
    tid: 168,
    slug: 'guochuang'
  },
  {
    // cinema
    name: '纪录片',
    type: 'cinema',
    slug: 'documentary',
    tid: 177,
    season_type: 3,
  },
  {
    name: '动画',
    tid: 1,
    slug: 'douga'
  },
  {
    name: '音乐',
    tid: 3,
    slug: 'music'
  },
  {
    name: '舞蹈',
    tid: 129,
    slug: 'dance'
  },
  {
    name: '游戏',
    tid: 4,
    slug: 'game'
  },
  {
    name: '知识',
    tid: 36,
    slug: 'technology'
  },
  {
    name: '数码',
    tid: 188,
    slug: 'digital'
  },
  {
    name: '生活',
    tid: 160,
    slug: 'life'
  },
  {
    name: '美食',
    tid: 211,
    slug: 'food'
  }, {
    name: '动物圈',
    tid: 217,
    slug: 'animal'
  }, {
    name: '鬼畜',
    tid: 119,
    slug: 'kichiku'
  },
  {
    name: '时尚',
    tid: 155,
    slug: 'fashion'
  },
  {
    name: '娱乐',
    tid: 5,
    slug: 'ent'
  },
  {
    name: '影视',
    tid: 181,
    slug: 'cinephile'
  },
  {
    // cinema
    name: '电影',
    type: 'cinema',
    slug: 'movie',
    tid: 23,
    season_type: 2,
  },
  {
    // cinema
    name: '电视剧',
    type: 'cinema',
    slug: 'tv',
    tid: 11,
    season_type: 5,
  },
  {
    name: '原创',
    slug: 'origin',
    tid: 0, // 全部分区
    rank_type: 'origin', // 原创榜
  },
  {
    name: '新人',
    slug: 'rookie',
    tid: 0, // 全部分区
    rank_type: 'rookie', // 新人榜
  },
]